module.exports = __webpack_public_path__ + "static/assets/e43a45d146c95cb23ba247257578a260.png";